import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-white/5 py-8 px-6 text-center text-slate-500 text-sm"
        >
            <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-x-6 gap-y-2">
                <span>© {year} All Purpose Ventures LLC · DBA The Butler Room</span>
                <span className="hidden sm:inline text-slate-700">·</span>
                <Link to="/terms" className="hover:text-[#D4AF37] transition" data-testid="footer-terms-link">Terms</Link>
                <Link to="/privacy" className="hover:text-[#D4AF37] transition" data-testid="footer-privacy-link">Privacy</Link>
                <a
                    href="mailto:info@allpurposeventures.com"
                    className="hover:text-[#D4AF37] transition"
                    data-testid="footer-contact-link"
                >
                    Contact
                </a>
            </div>
        </footer>
    );
}
